// extracted by mini-css-extract-plugin
export default {"searchInput":"main-searchInput_BKgty","searchIcon":"main-searchIcon_8N7R0","input":"main-input_OlTFS","clearButton":"main-clearButton_KOkFy"};